import { render, staticRenderFns } from "./StockUpSave.vue?vue&type=template&id=1df38650&scoped=true"
import script from "./StockUpSave.vue?vue&type=script&lang=js"
export * from "./StockUpSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df38650",
  null
  
)

export default component.exports